import React, { Component } from 'react';
import { Field } from 'redux-form';
import { Row, Col } from '$common';
import { Translate } from '$common';
import CSSModules from 'react-css-modules';
import style from '../task-form.scss';



let FormField = props => (
  <div styleName="form-field">
    <label htmlFor={props.name}>{props.label}</label>
    <Field
      name={props.name}
      type={props.type || 'text'}
      component={props => {
        return(
          <input
            type={props.type}
            placeholder={props.placeholder}
            className={props.className}
            defaultValue={props.input.value}
            onBlur={props.input.onChange}
          />
        )
      }}
      styleName="field"
      placeholder={props.placeholder || ''}
    />
  </div>
);
FormField = CSSModules(FormField, style);

export default class Range extends Component {
  static type = 'range';
  static elementName = Translate.get('range');
  static icon = 'sliders';

  render() {
    const { data } = this.props;

    return(
      <Row>
        <Col md="2/9">
          <FormField name={`${data}.min_label`} label="Min Label" />
        </Col>
        <Col md="2/9">
          <FormField name={`${data}.min`} label="Min Val" type="number"/>
        </Col>
        <Col md="1/9">
          <FormField name={`${data}.interval`} label="Interval" type="number"/>
        </Col>
        <Col md="2/9">
          <FormField name={`${data}.max`} label="Max Val" type="number"/>
        </Col>
        <Col md="2/9">
          <FormField name={`${data}.max_label`} label="Max Label" />
        </Col>
      </Row>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/task-form/question-types/range.js